/**
 * An empty function which does nothing.
 */
// eslint-disable-next-line @repo/internal/react/use-noop
export default function noop(): void {}
